export const MINUTOS_ADIAMENTO_PADRAO_LEMBRETE = 5;
export const OPCOES_ADIAMENTO_MINUTOS_LEMBRETE = [5, 15, 30, 60];
export const NOTAS_SOM_LEMBRETE = [{ frequencia: 1318.5, atraso: 0 }, { frequencia: 1760, atraso: 0.09 }];
export const VOLUME_SOM_LEMBRETE = 0.18;
export const DURACAO_NOTA_SOM_LEMBRETE_S = 0.45;
export const JANELA_SOM_LEMBRETE_MS = 15_000;
export const PREFIXO_CHAVE_SOM_LEMBRETE = 'lembrete-som-';
export const CURVA_ANIMACAO_LEMBRETE = 'cubic-bezier(.22,1,.36,1)';
export const DURACAO_ABERTURA_MODAL_LEMBRETE_MS = 460;
export const DURACAO_SAIDA_MODAL_LEMBRETE_MS = 200;
export const DURACAO_RETORNO_CARD_LEMBRETE_MS = 380;
export const GANHO_MINIMO_SOM_LEMBRETE = 0.0001;
export const ATAQUE_SOM_LEMBRETE_S = 0.01;
